<div class="invite-icon">
  <se-fe-icon
    seFeDataName="spot_family"
    seFeDataSize="950"
    seFeDataAriaLabel="success">
  </se-fe-icon>
</div>
<div *ngIf="invites?.length > 1" class="invite-description">{{ translationKey + "invite_review_plural" | translate }}</div>
<div *ngIf="invites?.length === 1" class="invite-description">{{ translationKey + "invite_review" | translate }}</div>
<div *ngFor="let invite of invites" class="invite-content">
  <se-po-guardian-invite-info
    [guardianToInvite]="invite"
    (cancelInvite)="onCancel(invite)">
  </se-po-guardian-invite-info>
</div>
<se-fe-button
  class="invite-button"
  seFeDataEmphasis="high"
  [seFeDataFullWidth]="true"
  (click)="onContinue()">
  {{ translationKey + 'BUTTONS.continue' | translate }}
</se-fe-button>
<se-fe-button *ngIf="canInviteGuardians"
  class="invite-button"
  [seFeDataFullWidth]="true"
  (click)="onInvite()">
  {{ translationKey + 'BUTTONS.invite_another' | translate }}
</se-fe-button>
